import * as React from "react";

import CostForm from "../../../components/Forms/LeaseContract/CostForm/FlowForm";

export default () => {
  return <CostForm />;
};
